import styled from 'styled-components'
import { theme } from '@notino/react-styleguide'

import { BREAKPOINTS } from '../../../styles/constants'
import { NotinoLabelRegular400, NotinoTitleMedium, resetButtonStyles } from '../../../styles/helpers'

export const ModalContent = styled.div`
	box-sizing: border-box;
	padding: 20px;
	display: flex;
	flex-direction: column;
	min-height: 100%;
	max-height: 100%;
	overflow: hidden;

	@media (min-width: ${BREAKPOINTS.sm}) {
		min-height: auto;
		max-height: none;
		overflow: visible;
		display: block;
	}
`

export const Header = styled.header`
	display: flex;
	justify-content: space-between;
	gap: 16px;
	margin-bottom: 20px;
`

export const HeaderTitle = styled.h2`
	${NotinoTitleMedium};
	margin: 0;
`

export const SimpleHeaderTitle = styled.h2`
	${NotinoTitleMedium};
	margin: 0 0 20px;
`

export const CloseButton = styled.button`
	${resetButtonStyles};
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;

	svg {
		pointer-events: none;
	}

	&:disabled {
		cursor: not-allowed;
		opacity: 0.5;
	}
`

export const Description = styled.p`
	color: ${theme.color.text.secondary};
	${NotinoLabelRegular400};
	margin: 0 0 24px;
`

export const Footer = styled.footer`
	display: flex;
	flex-direction: column;
	gap: 12px;
	width: 100%;
	flex-shrink: 0;
	margin-top: auto;

	@media (min-width: ${BREAKPOINTS.sm}) {
		flex-direction: row;
		margin-top: 0;
	}
`

export const FooterButton = styled.div`
	width: 100%;
	flex-shrink: 0;

	@media (min-width: ${BREAKPOINTS.sm}) {
		flex: 1 1 0;
		width: auto;
		min-width: 0;
	}
`
